import { render, staticRenderFns } from "./SummonsEdit.vue?vue&type=template&id=70754092&scoped=true&"
import script from "./SummonsEdit.vue?vue&type=script&lang=js&"
export * from "./SummonsEdit.vue?vue&type=script&lang=js&"
import style0 from "./SummonsEdit.vue?vue&type=style&index=0&id=70754092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70754092",
  null
  
)

export default component.exports